import { Component, Input } from '@angular/core';
import { EChartsOption } from 'echarts';

@Component({
  selector: 'ngx-donut-chart',
  template: `<div echarts [options]="ratingDonutOption" style="width: 64px;height: 64px;"></div>`,
})
export class DonutChartComponent {
  @Input() ratingDonutOption: EChartsOption = {};
}
